




























import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import AppContentCardThumbnail from '~/components/partials/App/AppContentCardThumbnail.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { THUMBNAIL_300 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import { sendGaEvent as sendEvent, GaTopPartsType } from '~/utils/ga';
import { ArticleCard } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppLink,
    AppContentCardThumbnail,
  },
  props: {
    item: {
      type: Object as PropType<ArticleCard>,
      required: true,
    },
    unresponsive: {
      type: Boolean,
      default: false,
    },
    gaPartsType: {
      type: String as PropType<GaTopPartsType>,
      default: null,
    },
    isRelatedContents: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const detailUrl = computed(() => props.item.url || url('ARCHIVES_DETAIL', { permalink: props.item.permalink }));
    const thumbnailImageSp = computed(() =>
      props.item.thumbnailImageSp ? props.item.thumbnailImageSp + THUMBNAIL_300 : undefined
    );
    const mainImageSp = computed(() => (props.item.mainImageSp ? props.item.mainImageSp + THUMBNAIL_300 : undefined));
    const thumbnailImagePc = computed(() =>
      props.item.thumbnailImagePc ? props.item.thumbnailImagePc + THUMBNAIL_300 : undefined
    );
    const mainImagePc = computed(() => (props.item.mainImagePc ? props.item.mainImagePc + THUMBNAIL_300 : undefined));

    const sendGaEvent = () => {
      if (!props.gaPartsType) {
        return;
      }
      sendEvent(props.gaPartsType, detailUrl.value, props.item.title);
    };

    return {
      thumbnailImageSp,
      thumbnailImagePc,
      mainImageSp,
      mainImagePc,
      detailUrl,
      sendGaEvent,
    };
  },
});
